// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"60f5512c","498":"b8426c4d","513":"a761203f","703":"777dbf8d"}[chunkId] + ".chunk.js";
};